import AppRestService from './app-rest.service';
import TheaterModel from '../models/theater.model';



/**
 * Service Endpoint Implementation
 */
export default class TheatersService extends AppRestService {

  constructor(opts = null) {
    super(opts);
    this.serviceName = 'theaters';
    this.routePath = 'theaters';
    this.idParamName = 'theater_id';
    this.modelClass = TheaterModel;
    this.authEnabled = true;
  }

}

